import * as React from 'react';

import $ from 'jquery';
import URI from 'jsuri';
import PropTypes from 'prop-types';
import type { LegacyContextType } from 'types/legacy-context-types';
import _ from 'underscore';
import connectToStores from 'vendor/cnpm/fluxible.v0-4/addons/connectToStores';

import connectToRouter from 'js/lib/connectToRouter';
import user from 'js/lib/user';
import { isOutsourcing } from 'js/utils/emailOutsourcingUtils';

import groupAuthorizationPromise from 'pages/open-course/common/promises/groupAuthorizationPromise';

import { ExternalLinkIcon } from '@coursera/cds-icons';

import {
  hideAdminDetails,
  highlightPost,
  showAdminDetails,
  showReplyEditor,
  unhighlightPost,
} from 'bundles/discussions/actions/DropdownActions';
import Delete from 'bundles/discussions/components/Delete';
import EditThreadModal from 'bundles/discussions/components/EditThreadModal';
import EditWithModerationModal from 'bundles/discussions/components/EditWithModerationModal';
import FlaggingModal from 'bundles/discussions/components/FlaggingModal';
import HighlightModal from 'bundles/discussions/components/HighlightModal';
import ShareModal from 'bundles/discussions/components/ShareModal';
import discussionsForumsHOC from 'bundles/discussions/components/discussionsForumsHOC';
import { buildUrl, getLearnerDetailedViewLink } from 'bundles/discussions/utils/discussionsUrl';
import routerConnectToCurrentForum from 'bundles/discussions/utils/routerConnectToCurrentForum';

/* @ts-expect-error ts-migrate(7016) FIXME: Untyped import */
import type GroupForumsV1 from 'bundles/naptimejs/resources/groupForums.v1';

/* @ts-expect-error ts-migrate(7016) FIXME: Untyped import */
import type OnDemandCourseForumsV1 from 'bundles/naptimejs/resources/onDemandCourseForums.v1';

/* @ts-expect-error ts-migrate(7016) FIXME: Untyped import */
import type OnDemandMentorForumsV1 from 'bundles/naptimejs/resources/onDemandMentorForums.v1';
import ProgrammingPermissionsUtils from 'bundles/programming-common/utils/ProgrammingPermissionsUtils';

import _t from 'i18n!nls/discussions';

import 'css!./__styles__/ModerationDropdown';

import type { KeysWithValsOfType } from '../types';

const escKeyCode = 27;

type InputProps = {
  creator: $TSFixMe;
  post: $TSFixMe;
  onDeleteSuccess?: (reason: $TSFixMe) => void;
  isHighlighted?: boolean;
  forumLink: string;
  isGradedDiscussionPrompt?: boolean;
  courseSlug?: string;
  courseId?: string;
  userId?: number;
  hasModerationRole?: boolean;
  currentForum?: OnDemandCourseForumsV1 | OnDemandMentorForumsV1 | GroupForumsV1;
  ariaDescribedBy?: string;
  onEditClick?: () => void;
  onDeleteClick?: () => void;
  onFlaggingClick?: () => void;
  onFlaggingSuccess?: () => void;
};

type PropsFromCompose = {
  hasTeachingRole: boolean;
  isProgrammingItem: boolean;
  itemId: string;
  isSuperuser: boolean;
  authenticated: boolean;
  question: $TSFixMe;
};

type Props = InputProps & PropsFromCompose;

type State = {
  expandDropdown: boolean;
  showDeleteModal: boolean;
  canModerate: boolean;
  showAdminDetailsToggle: boolean;
  showEditThreadModal: boolean;
  showEditWithModerationModal: boolean;
  showShareModal: boolean;
  showHighlightModal: boolean;
  showFlaggingModal: boolean;
};

class ModerationDropdown extends React.Component<Props, State> {
  static contextTypes = {
    executeAction: PropTypes.func.isRequired,
  };

  declare context: LegacyContextType<typeof ModerationDropdown.contextTypes>;

  static defaultProps = {
    isGradedDiscussionPrompt: false,
  };

  state: State = {
    expandDropdown: false,
    showDeleteModal: false,
    canModerate: false,
    showAdminDetailsToggle: false,
    showEditThreadModal: false,
    showEditWithModerationModal: false,
    showShareModal: false,
    showHighlightModal: false,
    showFlaggingModal: false,
  };

  declare node: HTMLDivElement | null | undefined;

  declare moderationDropdownButton: HTMLButtonElement | null | undefined;

  componentWillMount() {
    const { authenticated, isSuperuser, currentForum, hasModerationRole } = this.props;

    const groupId = currentForum && currentForum.forumType.definition.groupId;
    if (groupId) {
      groupAuthorizationPromise(groupId, authenticated, isSuperuser).then((result: $TSFixMe) => {
        // @ts-expect-error ts-migrate(2339) FIXME: Property '_isMounted' does not exist on type 'Mode... Remove this comment to see the full error message
        if (this._isMounted) {
          this.setState(result);
        }
      });
    } else {
      this.setState({ canModerate: hasModerationRole || isOutsourcing(user) });
    }
  }

  componentDidMount() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property '_isMounted' does not exist on type 'Mode... Remove this comment to see the full error message
    this._isMounted = true;
  }

  componentWillUnmount() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property '_isMounted' does not exist on type 'Mode... Remove this comment to see the full error message
    this._isMounted = false;
  }

  onEditClick = () => {
    const { creator, userId, post } = this.props;
    const postedByUser = creator?.userId === userId;

    this.props.onEditClick?.();

    if (!postedByUser && post.type !== 'question') {
      this.showEditWithModerationModal();
    } else {
      this.showEdit();
    }
  };

  onFlaggingClick = () => {
    this.props.onFlaggingClick?.();
    this.setState({ showFlaggingModal: true });
    this.closeDropdown();
  };

  onShareClick = () => {
    this.setState({ showShareModal: true });
    this.closeDropdown();
  };

  closeOnOutsideClick = (e: $TSFixMe) => {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'node' does not exist on type 'Moderation... Remove this comment to see the full error message
    if ($(this.node).find($(e.target)).length <= 0) {
      this.closeDropdown();
    }
  };

  closeOnOutsideFocus = (e: $TSFixMe) => {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'node' does not exist on type 'Moderation... Remove this comment to see the full error message
    const isBlurred = $(this.node).find($(e.target)).length <= 0;
    if (isBlurred) {
      this.closeDropdown();
    }
  };

  closeOnEscapeKey = (e: $TSFixMe) => {
    if (e.keyCode === escKeyCode) {
      this.closeDropdown();
    }
  };

  showAdminDetails = () => {
    const { executeAction } = this.context;
    const { post } = this.props;
    this.setState({ showAdminDetailsToggle: true });
    executeAction(showAdminDetails, { post });
    this.closeDropdown();
  };

  hideAdminDetails = () => {
    const { executeAction } = this.context;
    const { post } = this.props;
    this.setState({ showAdminDetailsToggle: false });
    executeAction(hideAdminDetails, { post });
    this.closeDropdown();
  };

  showUserGrades = () => {
    const { post } = this.props;
    window.open(getLearnerDetailedViewLink(post.creatorId), '_blank');
  };

  showDeleteModal = () => {
    this.props.onDeleteClick?.();
    this.setState({ showDeleteModal: true });
    this.closeDropdown();
  };

  editWithModerationModalSuccess = (reason: $TSFixMe, dontNotify: $TSFixMe) => {
    this.closeModal('showEditWithModerationModal');
    this.showEditReply(reason, dontNotify);
  };

  hideAllAriaSuccessAnnouncements = () => {
    this.props.onDeleteClick?.();
    this.props.onEditClick?.();
    this.props.onFlaggingClick?.();
  };

  toggleDropdown = () => {
    this.setState(({ expandDropdown }) => {
      const isExpanded = !expandDropdown;
      if (isExpanded) {
        this.attachListeners();
      } else {
        this.detachListeners();
      }
      return { expandDropdown: isExpanded };
    });
    this.hideAllAriaSuccessAnnouncements?.();
  };

  closeDropdown = () => {
    this.setState({ expandDropdown: false });
    this.detachListeners();
  };

  handleBlur: React.FocusEventHandler<HTMLDivElement> = (event: React.FocusEvent<HTMLElement>) => {
    const relatedElement = event.relatedTarget as HTMLElement;

    /* this closes the dropdown when the user focuses outside the dropdown.
       event.relatedTarget is the secondary target in the dropdown menu i.e. the focused menu item */
    if (!event.currentTarget.contains(relatedElement)) {
      if (this.state.expandDropdown) {
        this.closeDropdown();
      }
    }
  };

  attachListeners = () => {
    $('body').on('click', this.closeOnOutsideClick);
    $('body').on('keyup', this.closeOnOutsideFocus);
    $('body').on('keydown', this.closeOnEscapeKey);
  };

  detachListeners = () => {
    $('body').off('click', this.closeOnOutsideClick);
    $('body').off('keyup', this.closeOnOutsideFocus);
    $('body').off('keydown', this.closeOnEscapeKey);
  };

  showEdit = () => {
    const { post } = this.props;
    if (post.type === 'question') {
      this.showEditQuestion();
    } else {
      // @ts-expect-error ts-migrate(2554) FIXME: Expected 2 arguments, but got 0.
      this.showEditReply();
    }

    this.closeDropdown();
  };

  // Edit Question
  showEditQuestion() {
    this.setState({ showEditThreadModal: true });
  }

  // Edit Answer & Comment
  showEditReply(reason: $TSFixMe, dontNotify: $TSFixMe) {
    const { executeAction } = this.context;
    const { post } = this.props;
    executeAction(showReplyEditor, {
      reply: post,
      reason,
      dontNotify,
    });
  }

  // Edit Moderator Modal
  showEditWithModerationModal() {
    this.setState({ showEditWithModerationModal: true });
    this.closeDropdown();
  }

  showSubmissions = () => {
    const { post, courseSlug, itemId, courseId = '' } = this.props;
    const submissionUrl = new URI(
      `/teach/${courseSlug}/grading/assignment-grading/${itemId}/submission/${post.creatorId}`
    )
      // Note: always use base branch as versionId. use courseBranchId when PARTNER-11638 is resolved
      .addQueryParam('versionId', courseId)
      .toString();

    window.open(submissionUrl, '_blank');

    this.closeDropdown();
  };

  closeModal = (stateKey: KeysWithValsOfType<State, boolean>) => {
    // prevState is needed here to prevent typescript from complaining about using computed property names
    this.setState((prevState) => ({ ...prevState, [stateKey]: false }));
    this?.moderationDropdownButton?.focus();
  };

  render() {
    const {
      post,
      userId,
      forumLink,
      courseId,
      creator,
      hasTeachingRole,
      isSuperuser,
      isProgrammingItem,
      isHighlighted,
      onDeleteSuccess,
      isGradedDiscussionPrompt,
      ariaDescribedBy,
      onFlaggingSuccess,
    } = this.props;

    const {
      expandDropdown,
      showDeleteModal,
      showEditThreadModal,
      showEditWithModerationModal,
      showFlaggingModal,
      showShareModal,
      showHighlightModal,
      canModerate,
      showAdminDetailsToggle,
    } = this.state;

    const postedByUser = creator?.userId === userId;
    const hasProgrammingAdminPermissions = ProgrammingPermissionsUtils.hasAdminPrivileges(hasTeachingRole);
    const ariaLabel = creator?.fullName
      ? _t(`Settings Menu for #{userName}'s post`, { userName: creator?.fullName })
      : _t('Settings Menu');
    const postUrl =
      window.location.origin +
      buildUrl(forumLink, post.questionId, post.topLevelForumAnswerId, post.forumCommentId) +
      window.location.search; // We must include the ?page query param in order to link to the correct page

    return (
      <div
        className="rc-Dropdown align-self-start c-dropdown-position"
        ref={(node) => {
          this.node = node;
        }}
        onBlur={this.handleBlur}
      >
        <button
          type="button"
          aria-haspopup="menu"
          aria-expanded={expandDropdown}
          aria-label={ariaLabel}
          data-test-id="moderation-dropdown-button"
          onClick={this.toggleDropdown}
          ref={(moderationDropdownButtonRef) => {
            this.moderationDropdownButton = moderationDropdownButtonRef;
          }}
        >
          <i className="cif-chevron-down c-dropdown-chevron" />
        </button>

        {expandDropdown && (
          <ul className="styleguide dropdown" role="menu">
            {(postedByUser || canModerate) && (
              <li>
                <button type="button" data-js="edit" aria-describedby={ariaDescribedBy} onClick={this.onEditClick}>
                  {_t('Edit')}
                </button>
              </li>
            )}

            {((isGradedDiscussionPrompt && postedByUser) || canModerate) && (
              <li>
                <button
                  type="button"
                  data-js="delete"
                  aria-describedby={ariaDescribedBy}
                  onClick={this.showDeleteModal}
                >
                  {_t('Delete')}
                </button>
              </li>
            )}

            {!postedByUser && (
              <li>
                <button type="button" data-js="flag" aria-describedby={ariaDescribedBy} onClick={this.onFlaggingClick}>
                  {post.flagDetails && post.flagDetails.isActive ? _t('Resolve report') : _t('Report this')}
                </button>
              </li>
            )}

            {(hasTeachingRole || isSuperuser) && showAdminDetailsToggle && (
              <li>
                <button
                  type="button"
                  data-js="userId"
                  aria-describedby={ariaDescribedBy}
                  onClick={this.hideAdminDetails}
                >
                  {_t('Hide User ID')}
                </button>
              </li>
            )}

            {(hasTeachingRole || isSuperuser || isOutsourcing(user)) && !showAdminDetailsToggle && (
              <li>
                <button
                  type="button"
                  data-js="userId"
                  aria-describedby={ariaDescribedBy}
                  onClick={this.showAdminDetails}
                >
                  {_t('Show User ID')}
                </button>
              </li>
            )}

            {(hasTeachingRole || isSuperuser || isOutsourcing(user)) && (
              <li>
                <button
                  type="button"
                  data-js="userId"
                  aria-describedby={ariaDescribedBy}
                  onClick={this.showUserGrades}
                  aria-label={_t('View User Grades, opens in a new tab')}
                >
                  {_t('View User Grades')} <ExternalLinkIcon size="small" />
                </button>
              </li>
            )}

            {isProgrammingItem && hasProgrammingAdminPermissions && (
              <li>
                <button
                  type="button"
                  data-js="viewSubmissions"
                  aria-describedby={ariaDescribedBy}
                  onClick={this.showSubmissions}
                >
                  {_t('View submissions')}
                </button>
              </li>
            )}

            {!isGradedDiscussionPrompt && (
              <li>
                <button type="button" data-js="share" aria-describedby={ariaDescribedBy} onClick={this.onShareClick}>
                  {_t('Link to Post')}
                </button>
              </li>
            )}
          </ul>
        )}

        {showDeleteModal && (
          <Delete
            post={post}
            showReasons={!postedByUser}
            showNotifyUser={!isGradedDiscussionPrompt}
            onDeleteSuccess={onDeleteSuccess}
            handleClose={() => this.closeModal('showDeleteModal')}
          />
        )}

        {showEditThreadModal && (
          <EditThreadModal
            question={post}
            courseId={courseId}
            showReasons={!postedByUser}
            handleClose={() => this.closeModal('showEditThreadModal')}
          />
        )}

        {showEditWithModerationModal && (
          <EditWithModerationModal
            handleSuccess={this.editWithModerationModalSuccess}
            handleCancel={() => this.closeModal('showEditWithModerationModal')}
          />
        )}

        {showFlaggingModal && (
          <FlaggingModal
            post={post}
            handleClose={() => this.closeModal('showFlaggingModal')}
            onFlaggingSuccess={onFlaggingSuccess}
          />
        )}

        {showShareModal && <ShareModal postUrl={postUrl} handleClose={() => this.closeModal('showShareModal')} />}

        {showHighlightModal && (
          <HighlightModal
            isHighlighted={isHighlighted}
            handleCancel={() => this.closeModal('showHighlightModal')}
            handleAccept={() => {
              const { executeAction } = this.context;
              if (isHighlighted) {
                executeAction(unhighlightPost, { post });
              } else {
                executeAction(highlightPost, { post });
              }

              this.closeModal('showHighlightModal');
            }}
          />
        )}
      </div>
    );
  }
}

export default _.compose(
  discussionsForumsHOC({ fields: ['forumType'] }),
  connectToRouter(routerConnectToCurrentForum),
  connectToStores(
    ['CourseMembershipStore', 'CourseStore', 'ApplicationStore', 'ThreadDetailsStore'],
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'currentForum' does not exist on type '{}... Remove this comment to see the full error message
    ({ CourseMembershipStore, CourseStore, ApplicationStore, ThreadDetailsStore }, { currentForum, post }) => {
      const { questionId } = post;
      const itemId = currentForum && currentForum.forumType.definition.itemId;

      const itemMetadata = !!itemId && CourseStore.getMaterials().getItemMetadata(itemId);
      const maybeContentType = itemMetadata && itemMetadata.getTypeName();
      const isProgrammingItem = ['gradedProgramming', 'ungradedProgramming'].includes(maybeContentType);

      return {
        hasTeachingRole: CourseMembershipStore.hasTeachingRole(),
        isProgrammingItem,
        itemId,
        isSuperuser: ApplicationStore.isSuperuser(),
        authenticated: ApplicationStore.isAuthenticatedUser(),
        question: ThreadDetailsStore.getQuestion(questionId),
      };
    }
  )
)(ModerationDropdown);

export const BaseComponent = ModerationDropdown;
